import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import AdminLogin from './AdminLogin';
import DashboardHome from './DashboardHome';
import Appointments from './Appointments';
import AddBooking from './AddBooking';
import Analytics from './Analytics';
import CalendarView from './CalendarView';
import ClientHistory from './ClientHistory';
import Sidebar from '../components/Sidebar';
import { DashIcon, CalendarIcon, PlusIcon, BarChartIcon, UserIcon } from '../components/AdminIcons';

const TABS = [
  { id: 'dashboard',    label: 'Home',     Icon: DashIcon },
  { id: 'appointments', label: 'Bookings', Icon: CalendarIcon },
  { id: 'add',          label: 'Add',      Icon: PlusIcon },
  { id: 'clients',      label: 'Clients',  Icon: UserIcon },
  { id: 'analytics',    label: 'Stats',    Icon: BarChartIcon },
];

export default function AdminApp() {
  const [user, setUser]     = useState(null);
  const [checking, setChecking] = useState(true);
  const [page, setPage]     = useState('dashboard');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => {
      setUser(u);
      setChecking(false);
    });
    return unsub;
  }, []);

  // Browser notifications for new bookings
  useEffect(() => {
    if (!user) return;
    try {
      if (Notification && Notification.permission === 'default') {
        Notification.requestPermission();
      }
    } catch(e) {}

    const q = query(collection(db, 'bookings'), orderBy('createdAt', 'desc'));
    let first = true;
    let prevCount = 0;
    const unsub = onSnapshot(q, snap => {
      const count = snap.docs.length;
      if (first) { prevCount = count; first = false; return; }
      if (count > prevCount) {
        try {
          const latest = snap.docs[0].data();
          if (Notification && Notification.permission === 'granted') {
            new Notification('New Booking!', {
              body: (latest.name || 'Someone') + ' booked ' + (latest.service || 'an appointment'),
              icon: '/images/logo.jpg',
            });
          }
        } catch(e) {}
        prevCount = count;
      }
    });
    return unsub;
  }, [user]);

  if (checking) return (
    <div style={{ minHeight:'100vh', background:'#060E1E', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ color:'rgba(255,255,255,0.5)', fontFamily:'Jost,sans-serif', fontSize:'0.9rem' }}>Loading...</div>
    </div>
  );

  if (!user) return <AdminLogin onLogin={() => {}} />;

  const renderPage = () => {
    switch (page) {
      case 'dashboard':    return <DashboardHome setPage={setPage} />;
      case 'appointments': return <Appointments />;
      case 'add':          return <AddBooking setPage={setPage} />;
      case 'analytics':    return <Analytics />;
      case 'calendar':     return <CalendarView setPage={setPage} />;
      case 'clients':      return <ClientHistory />;
      default:             return <DashboardHome setPage={setPage} />;
    }
  };

  return (
    <div className="admin-wrap">
      <Sidebar active={page} setPage={setPage} />
      <div className="admin-main">
        {renderPage()}
      </div>
      {/* Mobile bottom tab bar */}
      <nav className="admin-bottom-nav">
        {TABS.map(({ id, label, Icon }) => (
          <button key={id} onClick={() => setPage(id)} className={page === id ? 'active' : ''}>
            <Icon s={20} />
            {label}
          </button>
        ))}
      </nav>
    </div>
  );
}
